import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";
import logoLarge from "../../assets/images/K2Charge.png";
import logoSmall from "../../assets/images/logo-small.png"
import lightDark from '../../Components/Common/LightDark';
import logoNew from "../../assets/images/logo-new.png";
import logoNewBlack from "../../assets/images/logo-new-black.png";
import logoNewSmall from "../../assets/images/logo-new-small.png";
import mainLogo from "../../assets//images/mainicon.png"

export const Images = {
  logoSm,
  logoDark,
  logoLight,
  logoLarge,
  logoSmall,
  lightDark,
  logoNew,
  logoNewSmall,
  logoNewBlack,
  mainLogo
};